module.exports = __webpack_public_path__ + "img/protfolio-2.f97b72e8.png";